import { type EventSeriesData } from '@beat-venues/common-types';
import type { CommonProps } from '../../types';
import { useRef, type JSX } from 'react';
import {
    EventStory,
    HeadingLayout,
    Swimlane,
    useDraggableScroll,
} from '../../';

export interface EventCollectionProps extends CommonProps {
    title?: string;
    events: Pick<EventSeriesData, 'name' | 'slug' | 'image' | 'hash'>[];
    layout: 'default' | 'vip' | 'mainBrand';
}

export const EventCollection = ({
    className,
    events,
    title,
    layout,
    testId = 'event-collection',
    ...props
}: EventCollectionProps): JSX.Element => {
    const scrollRef = useRef<HTMLDivElement>(null);
    const { mouseDownHandler } = useDraggableScroll(scrollRef.current);

    return (
        <div className={className} {...props} data-testid={testId}>
            <Swimlane layout={layout}>
                <HeadingLayout
                    invertFontColor={layout === 'vip'}
                    isVIP={layout === 'vip'}
                    title={title}
                >
                    <div
                        ref={scrollRef}
                        className="tile-overflow-grid auto-cols-[calc((100%-0.5rem)/2)] md:auto-cols-[calc((100%-3rem)/3)] lg:auto-cols-[calc((100%-3rem)/4)]"
                        onMouseDown={mouseDownHandler}
                    >
                        {events?.map((event) => (
                            <EventStory
                                key={event.hash}
                                image={event.image}
                                title={event.name}
                                href={event.slug}
                            />
                        ))}
                    </div>
                </HeadingLayout>
            </Swimlane>
        </div>
    );
};
